import Dexie, { type Table } from 'dexie'
import type {
  Team, Season, Player, SeasonRoster, Game, StatEntry,
  Lineup, LineupSlot, SyncMeta, CalendarEvent, Opponent, DrillTemplate,
} from '@/types'

export class WhistleDatabase extends Dexie {
  teams!: Table<Team>
  seasons!: Table<Season>
  players!: Table<Player>
  seasonRosters!: Table<SeasonRoster>
  games!: Table<Game>
  statEntries!: Table<StatEntry>
  lineups!: Table<Lineup>
  lineupSlots!: Table<LineupSlot>
  syncMeta!: Table<SyncMeta>
  events!: Table<CalendarEvent>
  opponents!: Table<Opponent>
  drillTemplates!: Table<DrillTemplate>

  constructor() {
    super('whistle')

    this.version(1).stores({
      teams: 'id, sportProfileId, updatedAt, syncedAt',
      seasons: 'id, teamId, isActive, updatedAt, syncedAt',
      players: 'id, isActive, isAvailable, updatedAt, syncedAt',
      seasonRosters: '[seasonId+playerId], seasonId, playerId',
      games: 'id, seasonId, gameDate, updatedAt, syncedAt',
      statEntries: 'id, gameId, playerId, statKey, recordedAt, syncedAt',
      lineups: 'id, gameId, updatedAt, syncedAt',
      lineupSlots: '[lineupId+playerId], lineupId, playerId',
      syncMeta: 'tableKey',
    })

    this.version(2).stores({
      events: 'id, seasonId, date',
    })

    this.version(3).stores({
      opponents: 'id, teamId, updatedAt, syncedAt',
    })

    // Version 4: adds drill template library
    this.version(4).stores({
      drillTemplates: 'id, teamId, focusArea, updatedAt, syncedAt',
    })
  }
}

export const db = new WhistleDatabase()
